import React, { useEffect, useState } from "react";

const formatNumber = (num) => {
  var num_parts = num.toString().split(".");
  num_parts[0] = num_parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  return num_parts.join(".");
};

const pad = (a, b) => {
  return (1e15 + a + "").slice(-b);
};

const AnalyticsRow = ({ data, categories, handleUpdatedData }) => {
  const [currentData, setCurrentData] = useState(null);
  const tongbai =
    data.report && data.report.count && data.report.count.countList && data.report.count.countList.length > 0
      ? parseInt(data.report.count.countList.reduce((a, b) => a + b, 0))
      : "";
  const kpi = parseInt(
    categories.find(({ value }) => value === data.value).kpi
  );
  // GAv4 UA
  let tongview = 0;
  if(data.report && data.report.sum && data.report.sum.reports[0].data){
    tongview =
    data.report && data.report.sum
      ? parseInt(data.report.sum.reports[0].data.totals[0].values[0])
      : "";
  }
  if(data.report && data.report.sum && data.report.sum.reports && data.report.sum.reports.length > 1 && data.report.sum.reports[0].rows && data.report.sum.reports[0].rows.length > 1 && data.report.sum.reports[0].rows[0].metricValues && data.report.sum.reports[0].rows[0].metricValues.length > 1 && data.report.sum.reports[0].rows[0].metricValues){
    tongview =
    data.report && data.report.sum
      ? parseInt(data.report.sum.reports[0].rows[0].metricValues[0].value)
      : "";
  }
  
  const tilekpi =
    data.report && tongview > 0 && kpi > 0 ? (tongview / kpi) * 100 : "";

  let tongviewgoogle = 0;
  if(data.report && data.report.google && data.report.google.reports[0].data){
    tongviewgoogle =
    data.report && data.report.google
      ? parseInt(data.report.google.reports[0].data.totals[0].values[0])
      : "";
  }
  if(data.report && data.report.google && data.report.google.reports[0].rows){
    tongviewgoogle =
    data.report && data.report.google
      ? parseInt(data.report.google.reports[0].rows[0].metricValues[0].value)
      : "";
  }
  const tilegoogle =
    data.report && tongview > 0 && tongviewgoogle > 0
      ? (tongviewgoogle / tongview) * 100
      : "";
  let tongviewfb = 0;
  if(data.report && data.report.fb && data.report.fb.reports[0].data){
    tongviewfb =
    data.report && data.report.fb
      ? parseInt(data.report.fb.reports[0].data.totals[0].values[0])
      : "";
  }
  if(data.report && data.report.fb && data.report.fb.reports[0].rows){
    tongviewfb =
    data.report && data.report.fb && data.report.fb.reports[0] && data.report.fb.reports[0].rows[0] && data.report.fb.reports[0].rows[0].metricValues[0]
      ? parseInt(data.report.fb.reports[0].rows[0].metricValues[0].value)
      : "";
  }
  const tilefbview =
    data.report && tongview > 0 && tongviewfb > 0
      ? (tongviewfb / tongview) * 100
      : "";

  useEffect(() => {
    if (JSON.stringify(data) !== JSON.stringify(currentData)) {
      if (currentData && handleUpdatedData) {
        handleUpdatedData(data);
      }

      setCurrentData(data);

    }
  }, [data]);
  return (
    <tr
      className={
        data.value == "" ? "bg-gradient-warning font-weight-bold text-dark" : ""
      }
    >
      <td>{categories.find(({ value }) => value === data.value).label}</td>
      <td>{formatNumber(tongbai)}</td>
      <td className="hide-column">{formatNumber(kpi)}</td>
      <td>{formatNumber(tongview)}</td>
      <td className={tilekpi >= 100 ? "text-success hide-column" : "hide-column"}>
        {tilekpi ? parseFloat(tilekpi).toFixed(2).replace(".",",") : ""}%
      </td>
      <td>{formatNumber(tongviewgoogle)}</td>
      <td className={tilegoogle > 50 ? "text-success" : ""}>
        {tilegoogle ? parseFloat(tilegoogle).toFixed(2).replace(".",",") : ""}%
      </td>
      <td>{formatNumber(tongviewfb)}</td>
      <td className={tilefbview > 50 ? "text-success" : ""}>
        {tilefbview ? parseFloat(tilefbview).toFixed(2).replace(".",",") : ""}%
      </td>
    </tr>
  );
};

export default AnalyticsRow;
